import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'ui/component/Button.tsx';
import { Modal } from 'ui/component/Modal.tsx';

type Props = {
  isOpen: boolean;
  message: string;
  title?: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'default' | 'danger';
};

const confirmButtonClassName: Record<Props['variant'] & string, string> = {
  default: 'blue',
  danger: 'red',
};

export const ConfirmDialog: React.FC<Props> = ({ isOpen, message, title, onConfirm, onCancel, loading, confirmLabel, cancelLabel, variant = 'default' }) => {
  const { t } = useTranslation();
  return (
    <Modal title={title ? <h4>{title}</h4> : undefined} isOpen={isOpen} onClose={onCancel}>
      <div className="flex w-[450px] flex-col gap-8">
        <p className="text-center">{message}</p>
        <div className="mt-6 flex w-full gap-4">
          <Button onClick={onCancel} className="blue-outlined" disabled={loading}>
            {cancelLabel ?? t('actions.back')}
          </Button>
          <Button loading={loading} onClick={onConfirm} className={confirmButtonClassName[variant]}>
            {confirmLabel ?? t('actions.confirm')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
